import { render, staticRenderFns } from "./VueJsModalWrapper.vue?vue&type=template&id=235b64b5&scoped=true&"
import script from "./VueJsModalWrapper.vue?vue&type=script&lang=js&"
export * from "./VueJsModalWrapper.vue?vue&type=script&lang=js&"
import style1 from "./VueJsModalWrapper.vue?vue&type=style&index=1&id=235b64b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235b64b5",
  null
  
)

export default component.exports